module.exports = __webpack_public_path__ + "static/media/greateVictory-3.35abd106.png";